module.exports = __webpack_public_path__ + "img/video-2-cover.a915f231.jpg";